export const fileUploadTheme = {
  header: {
    padding: 'var(--reset)',
  },
  content: {
    padding: 'var(--reset)',
    gap: 'var(--reset)',
  },
  extend: {
    agility: {
      contentBorder: 'var(--reset-none)',
      chooseButton: {
        icon: {
          display: 'none',
        },
      },
      progressbar: {
        display: 'none',
      },
    },
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--transparent)',
      },
    },
    dark: {
      root: {
        background: 'var(--transparent)',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-fileupload-advanced {
    border: ${dt('fileupload.agility.contentBorder')};
  }
  .p-fileupload-choose-button .p-iconwrapper {
      display: ${dt('fileupload.agility.chooseButton.icon.display')};
  }
  .p-fileupload-content p-progressbar {
    display: ${dt('fileupload.agility.progressbar.display')};
  }
  `,
};
